import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_mb-0" }
const _hoisted_2 = { class: "_mb-3 _mt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": $props.isOpen,
    "is-processing": _ctx.isProcessing,
    title: _ctx.Resources.YourPledge.RemainingInstallmentsModalHeader
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link",
        onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onClose && $options.onClose(...args)), ["prevent"])),
        "data-qa": "modal-button:cancel"
      }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
      _createVNode(_component_base_button, {
        width: "wide",
        theme: "accent",
        onClick: $options.onPayRemainingInstallments,
        "data-qa": "modal-button:Yes"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalYesButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.Resources.YourPledge.RemainingInstallmentsModalText), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_2, _toDisplayString($options.payRemainingInfo), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "is-processing", "title"]))
}